module.exports = __webpack_public_path__ + "/public/images/99f06ee1344e12dee060155236aa5e70.png";